const pagos = {
    
    
}

const firmas = {

    BuscarVerificaciondeRecibodeFirmas: 'SIVAC/Verificacion/Firmas/BuscarVerificaciondeRecibodeFirmas',
    
}

const verificacion = {
    pagos: pagos,
    firmas: firmas
}

export default verificacion;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SIVAC/Sistema/Verificacion/verificacion.js
// module id = null
// module chunks = 